<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <span class="text-weight-bold text-subtitle-1">Dashboard</span>
      </v-col>
      <v-col
        xl="4"
        lg="4"
        md="4"
        sm="12"
        cols="12"
        :class="$vuetify.breakpoint.smAndDown ? 'py-1' : ''"
      >
        <v-card class="rounded-lg dashboard-card" elevation="1">
          <v-card-text>
            <v-row>
              <v-col cols="6" class="px-1 d-flex align-center">
                <span
                  class="py-1 px-1 mr-2 rounded-lg"
                  style="background: #f1f2f6"
                >
                  <v-icon class="imgStyle" size="23">mdi-unity</v-icon>
                </span>
                <span class="text-h6">Total Units</span>
              </v-col>
              <v-col cols="6" align="end">
                <v-icon class="imgStyle" size="23"
                  >mdi-information-outline</v-icon
                >
              </v-col>
              <v-col cols="3" class="pr-0 mt-1">
                <span class="font-weight-bold text-h5"> {{ count }} </span>
              </v-col>
              <v-col cols="6" class="pl-0">
                <vs-button
                  flat
                  class="rounded-lg text-caption"
                  target="_blank"
                  @click="GetUnitData()"
                  color="success"
                >
                  <span> View List</span>
                  <span
                    ><v-icon color="success" size="16"
                      >mdi-arrow-top-right-thin</v-icon
                    ></span
                  >
                </vs-button>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        xl="4"
        lg="4"
        md="4"
        sm="12"
        cols="12"
        :class="$vuetify.breakpoint.smAndDown ? 'py-1' : ''"
      >
        <v-card class="rounded-lg dashboard-card" elevation="1">
          <v-card-text>
            <v-row>
              <v-col cols="8" class="px-1 d-flex align-center">
                <span
                  class="py-1 px-1 mr-2 rounded-lg"
                  style="background: #f1f2f6"
                >
                  <v-icon class="imgStyle" size="23"
                    >mdi-fan-chevron-down</v-icon
                  >
                </span>
                <span class="text-h6">Total Active Units</span>
              </v-col>
              <v-col cols="4" align="end">
                <v-icon class="imgStyle" size="23"
                  >mdi-information-outline</v-icon
                >
              </v-col>
              <v-col cols="3" class="pr-0 mt-1">
                <span class="font-weight-bold text-h5">
                  {{ activeUnitCount }}
                </span>
              </v-col>
              <v-col cols="6" class="pl-0">
                <vs-button
                  flat
                  class="rounded-lg text-caption"
                  target="_blank"
                  @click="GetUnitData(true)"
                  color="success"
                >
                  <span> View List</span>
                  <span
                    ><v-icon color="success" size="16"
                      >mdi-arrow-top-right-thin</v-icon
                    ></span
                  >
                </vs-button>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        xl="4"
        lg="4"
        md="4"
        sm="12"
        cols="12"
        :class="$vuetify.breakpoint.smAndDown ? 'py-1' : ''"
      >
        <v-card class="rounded-lg dashboard-card" elevation="1">
          <v-card-text>
            <v-row>
              <v-col cols="8" class="px-1 d-flex align-center">
                <span
                  class="py-1 px-1 mr-2 rounded-lg"
                  style="background: #f1f2f6"
                >
                  <v-icon class="imgStyle" size="23">mdi-fan-off</v-icon>
                </span>
                <span class="text-h6">Total In-Active Units</span>
              </v-col>
              <v-col cols="4" align="end">
                <v-icon class="imgStyle" size="23"
                  >mdi-information-outline</v-icon
                >
              </v-col>
              <v-col cols="3" class="pr-0 mt-1">
                <span class="font-weight-bold text-h5">
                  {{ InActiveUnitCount }}
                </span>
              </v-col>
              <v-col cols="6" class="pl-0">
                <vs-button
                  flat
                  class="rounded-lg text-caption"
                  target="_blank"
                  @click="GetUnitData(false)"
                  color="danger"
                >
                  <span> View List</span>
                  <span
                    ><v-icon color="error" size="16"
                      >mdi-arrow-top-right-thin</v-icon
                    ></span
                  >
                </vs-button>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col xl="7" lg="7" md="7" sm="12" cols="12" class="pt-0">
        <v-card class="rounded-lg">
          <apexchart
            type="bar"
            height="400"
            :options="chartOptions"
            :series="series"
          ></apexchart>
        </v-card>
      </v-col>
      <v-col xl="5" lg="5" md="5" sm="12" cols="12" class="pt-0">
        <v-card class="rounded-lg">
          <apexchart
            type="bar"
            height="400"
            :options="chartOptions2"
            :series="series2"
          ></apexchart>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card elevation="0">
          <v-card-title class="pb-0">
            <v-col cols="12" class="px-0 pb-1 pt-0">
              <v-col cols="12" class="py-0">
                <span class="text-h6">Total units count ({{ count }})</span>
              </v-col>
            </v-col>
            <vs-button
              class="mx-2 text-caption"
              color="#6c5dd4"
              to="units/create"
              >+ Add Unit</vs-button
            >
            <v-spacer></v-spacer>
            <vs-pagination
              v-model="page"
              color="#6c5dd4"
              :length="paginationLength"
            >
            </vs-pagination>
            <vs-input
              class="search-field-input text-caption"
              v-model="search_keyword"
              placeholder="Search ... "
              prepend-inner-icon="mdi-magnify"
              @keydown.enter="getData"
              @change="page = 1"
              clearable
            ></vs-input>
            <vs-button
              v-if="units.length != 0"
              :class="[
                $vuetify.breakpoint.smAndDown ? 'ml-4' : 'mx-4',
                'text-caption',
              ]"
              color="#6c5dd4"
              :loading="isExcelloading"
              :disabled="isExcelloading"
              @click="generateExcel()"
              >Generate Excel</vs-button
            >
          </v-card-title>
          <v-progress-linear
            v-if="isLoading"
            indeterminate
            color="#6c5dd4"
          ></v-progress-linear>
          <v-simple-table fixed-header>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Sr No</th>
                  <th class="text-left">Name</th>
                  <th class="text-left">Address</th>
                  <th class="text-left">Latitude</th>
                  <th class="text-left">Longitude</th>
                  <th class="text-left">IMEI No</th>
                  <th class="text-center">Action</th>
                </tr>
              </thead>
              <tbody v-if="units.length != 0">
                <tr v-for="(unit, i) in units" :key="`unit${i}`">
                  <td style="min-width: 85px">
                    <v-tooltip bottom v-if="unit.is_active == 1">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          small
                          dark
                          color="green"
                        >
                          mdi-circle
                        </v-icon>
                      </template>
                      <span>unit is Active</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="unit.is_active == 0">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" small dark color="red">
                          mdi-circle
                        </v-icon>
                      </template>
                      <span>unit is InActive</span>
                    </v-tooltip>
                    &nbsp;
                    {{ i + 1 }}
                  </td>
                  <td style="position: relative">
                    {{ unit.first_name || ""
                    }}<iframe
                      v-if="unit.is_active == true"
                      src="https://giphy.com/embed/2QlWRjEHV0qw0JuOj7"
                      width="30px"
                      height="20px"
                      style="position: absolute"
                      frameBorder="0"
                    ></iframe>
                  </td>
                  <td>{{ unit.residence_address || "" }}</td>
                  <td>{{ unit.latitude || "" }}</td>
                  <td>{{ unit.longitude || "" }}</td>
                  <td>{{ unit.imei_number || "" }}</td>
                  <td class="text-center">
                    <div
                      v-if="$vuetify.breakpoint.smAndDown"
                      class="text-center"
                    >
                      <v-menu stransition="slide-x-transition" bottom left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="white"
                            class="px-0"
                            min-width="21"
                            height="29"
                            elevation="1"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon>mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item :to="`/units/${unit.id}`">
                            <v-list-item-title class="text-caption">
                              Edit Unit</v-list-item-title
                            >
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-title
                              :to="`/datas/${unit.id}`"
                              class="text-caption"
                            >
                              View Unit Data</v-list-item-title
                            >
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                    <v-row v-else justify="center">
                      <v-btn
                        class="mx-2"
                        fab
                        x-small
                        elevation="0"
                        color="#6c5dd4"
                        :to="`units/${unit.id}`"
                        dark
                      >
                        <v-icon dark> mdi-pencil </v-icon>
                      </v-btn>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            :to="`/datas/${unit.id}`"
                            elevation="0"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-img
                              :src="require('../../assets/speedometer.gif')"
                              width="50"
                            />
                          </v-btn>
                        </template>
                        <span>View Unit Data</span>
                      </v-tooltip>
                    </v-row>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="12" class="text-center">No data found</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-col>
    </v-row>
    <vs-dialog v-model="UnitsDialog">
      <v-card elevation="0">
        <v-card-title class="pb-0">
          <vs-pagination
            v-model="page"
            color="#6c5dd4"
            :length="paginationLength"
          >
          </vs-pagination>
          <v-spacer></v-spacer>
          <vs-input
            class="search-field-input text-caption"
            v-model="search_keyword"
            placeholder="Search ... "
            prepend-inner-icon="mdi-magnify"
            @keydown.enter="getData"
            @change="page = 1"
            clearable
          ></vs-input>
        </v-card-title>
        <v-progress-linear
          v-if="isLoading"
          indeterminate
          color="#6c5dd4"
        ></v-progress-linear>
        <v-simple-table fixed-header>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Sr No</th>
                <th class="text-left">Name</th>
                <th class="text-left">Address</th>
                <th class="text-left">Latitude</th>
                <th class="text-left">Longitude</th>
                <th class="text-left">IMEI No</th>
                <th class="text-center">Action</th>
              </tr>
            </thead>
            <tbody v-if="unitcards.length != 0">
              <tr v-for="(unit, i) in unitcards" :key="`unit${i}`">
                <td style="min-width: 85px">
                  <v-tooltip bottom v-if="unit.is_active == 1">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" small dark color="green">
                        mdi-circle
                      </v-icon>
                    </template>
                    <span>unit is Active</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="unit.is_active == 0">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" small dark color="red">
                        mdi-circle
                      </v-icon>
                    </template>
                    <span>unit is InActive</span>
                  </v-tooltip>
                  &nbsp;
                  {{ i + 1 }}
                </td>
                <td style="position: relative">
                  {{ unit.first_name || ""
                  }}<iframe
                    v-if="unit.is_active == true"
                    src="https://giphy.com/embed/2QlWRjEHV0qw0JuOj7"
                    width="30px"
                    height="20px"
                    style="position: absolute"
                    frameBorder="0"
                  ></iframe>
                </td>
                <td>{{ unit.residence_address || "" }}</td>
                <td>{{ unit.latitude || "" }}</td>
                <td>{{ unit.longitude || "" }}</td>
                <td>{{ unit.imei_number || "" }}</td>
                <td class="text-center">
                  <div v-if="$vuetify.breakpoint.smAndDown" class="text-center">
                    <v-menu stransition="slide-x-transition" bottom left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="white"
                          class="px-0"
                          min-width="21"
                          height="29"
                          elevation="1"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item :to="`/units/${unit.id}`">
                          <v-list-item-title class="text-caption">
                            Edit Unit</v-list-item-title
                          >
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-title
                            :to="`/datas/${unit.id}`"
                            class="text-caption"
                          >
                            View Unit Data</v-list-item-title
                          >
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                  <v-row v-else justify="center">
                    <v-btn
                      class="mx-2"
                      fab
                      x-small
                      elevation="0"
                      color="#6c5dd4"
                      :to="`units/${unit.id}`"
                      dark
                    >
                      <v-icon dark> mdi-pencil </v-icon>
                    </v-btn>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          :to="`/datas/${unit.id}`"
                          elevation="0"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-img
                            :src="require('../../assets/speedometer.gif')"
                            width="50"
                          />
                        </v-btn>
                      </template>
                      <span>View Unit Data</span>
                    </v-tooltip>
                  </v-row>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="12" class="text-center">No data found</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </vs-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import VueApexCharts from "vue3-apexcharts";

export default {
  name: "SACounts",
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      counts: {},
      units: {},
      unitcards: {},
      status_wise_counts: {},
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      UnitsDialog: false,
      search_keyword: "",
      isLoading: false,
      isExcelloading: false,
      InActiveUnitCount: "",
      activeUnitCount: "",
      series: [],
      chartOptions: {
        chart: {
          height: 200,
          type: "bar",
          zoom: {
            enabled: false,
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: "bottom",
            },
          },
        },

        dataLabels: {
          enabled: true,
          textAnchor: "start",
          style: {
            colors: ["#fff"],
          },
          formatter: function (val, opt) {
            return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val;
          },
          offsetX: 0,
          dropShadow: {
            enabled: true,
          },
        },
        stroke: {
          curve: "straight",
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"],
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [
            "System On",
            "System off",
            "Input High",
            "Input Low",
            "Output High",
            "Output Low",
            "Battery High",
            "Battery Low",
            "Over Temperature",
          ],
        },
      },
      series2: [
      ],
      chartOptions2: {
        chart: {
          height: 200,
          type: "bar",
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            distributed: true,
            dataLabels: {
              position: "center",
            },
          },
        },
        dataLabels: {
          enabled: true,
          offsetY: 10,
          style: {
            fontSize: "12px",
            colors: ["#fff"],
          },
          offsetX: 0,
        },

        xaxis: {
          categories: [
            "Overload",
            "Short",
            "Dsat",
            "Ground Fault",
            "Dry Run",
            "Water Tank Full",
            "Phase Open",
            "Phase Unbalance",
            "No Status",
          ],
          position: "top",
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          crosshairs: {
            fill: {
              type: "gradient",
              gradient: {
                colorFrom: "#D8E3F0",
                colorTo: "#BED1E6",
                stops: [0, 100],
                opacityFrom: 0.4,
                opacityTo: 0.5,
              },
            },
          },
          tooltip: {
            enabled: true,
          },
        },
      },
    };
  },
  computed: {
    companyId() {
      if (this.roleName === "Super Admin") {
        return this.$store.getters["settings/getCompanyId"];
      } else {
        return null;
      }
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.search_keyword = this.search_keyword ? this.search_keyword : "";
      let units = [];
      let status_wise_counts = [];
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&search_keyword=" +
        this.search_keyword;
      if (this.roleName == "Super Admin") {
        const config = {
          headers: {
            "Company-id": this.companyId,
          },
        };
        status_wise_counts = await axios.get(`dashboard_count`, config);
        units = await axios.get(`units?${query}`, config);
      } else {
        status_wise_counts = await axios.get(`dashboard_count`);
        units = await axios.get(`units?${query}`);
      }
      this.units = units.data.data;
      this.status_wise_counts = status_wise_counts.data.status_wise_count;
      if (this.status_wise_counts != null) {
        this.getChartUpdate();
      }
      console.log(this.status_wise_counts);
      this.count = units.data.count;
      this.activeUnitCount = this.units.filter(
        (unit) => unit.is_active == true
      ).length;
      this.InActiveUnitCount = this.units.filter(
        (unit) => unit.is_active == false
      ).length;
      this.isLoading = false;
    },
    async generateExcel() {
      this.isExcelloading = true;
      let query = "search_keyword=" + this.search_keyword;
      let response = [];
      try {
        if (this.roleName == "Super Admin") {
          const config = {
            headers: {
              "Company-id": this.companyId,
            },
          };
          response = await axios.get(`unitsExport?${query}`, config);
        } else {
          response = await axios.get(`unitsExport?${query}`);
        }
        if (response && response.data && response.data.data) {
          window.open(`${response.data.data}`, "_blank");
        } else {
          console.error("Invalid response data:", response.data);
        }
      } catch (error) {
        console.error("Error fetching Excel data:", error);
      }
      this.isExcelloading = false;
    },
    GetUnitData(unit) {
      if (unit == true) {
        this.unitcards = this.units.filter((unit) => unit.is_active == true);
        this.UnitsDialog = true;
      } else if (unit == false) {
        this.unitcards = this.units.filter((unit) => unit.is_active == false);
        this.UnitsDialog = true;
      } else {
        this.unitcards = this.units;
        this.UnitsDialog = true;
      }
    },
    getChartUpdate() {
      // Define an array to hold the names of the status types you want to include
      const includedStatuses = [
        "SystemOn",
        "SystemOff",
        "InputHigh",
        "InputLow",
        "OutputHigh",
        "OutputLow",
        "BatteryHigh",
        "BatteryLow",
        "OverTemperature",
      ];
      const includedStatuses2 = [
        "Overload",
        "Short",
        "DSAT",
        "PhaseOpen",
        "PhaseUnbalance",
        "GroundFault",
        "DryRun",
        "WaterTankFull",
        "NoStatus",
      ];
      const filteredCounts = [];
      const filteredCounts2 = [];
      // Loop through the included status types and push their counts into the filteredCounts array
      includedStatuses.forEach((status) => {
        if (status in this.status_wise_counts) {
          filteredCounts.push(this.status_wise_counts[status]);
        } else {
          filteredCounts.push(0); // Push 0 if the status type is not found
        }
      });
      includedStatuses2.forEach((status) => {
        if (status in this.status_wise_counts) {
          filteredCounts2.push(this.status_wise_counts[status]);
        } else {
          filteredCounts2.push(0); 
        }
      });
      this.series = [
        {
          name: "Count",
          data: filteredCounts,
        },
      ];
      this.series2 = [
        {
          name: "Count",
          data: filteredCounts2,
        },
      ];
    },
  },
};
</script>
